// Entrypoint compiled by Vite (see vite.config.ts / config/vite.json). Keep it a thin reference
// layer — the actual application logic lives under app/javascript/frontend.

// Must come first: publishes window.$ / window.jQuery before any jQuery plugin is evaluated.
import '../frontend/jquery-setup.js'

import Rails from '@rails/ujs'
import Turbolinks from 'turbolinks'
// Namespace import, not default: activestorage's UMD populates `exports` rather than assigning
// `module.exports`, so the CommonJS interop hands back named exports and no default binding.
import * as ActiveStorage from '@rails/activestorage'
import 'popper.js'

Rails.start()
Turbolinks.start()
ActiveStorage.start()

// CSP nonces are generated per request. Turbolinks XHR-loads new pages whose
// inline <script nonce="..."> tags carry a fresh nonce, but the browser still
// enforces the ORIGINAL page's CSP header (which only knows the original
// nonce — HTTP headers can't be retroactively changed by XHR responses).
// Turbolinks also merges the new <meta name="csp-nonce"> into the live head,
// so by render time the meta no longer reflects the original. We capture the
// initial nonce at pack load and rewrite every incoming inline script to use
// it. Without this, body scripts like notifierDict get CSP-blocked on every
// Turbolinks navigation until a full reload.
const initialCspNonce = document.querySelector('meta[name="csp-nonce"]')?.content
document.addEventListener('turbolinks:before-render', (event) => {
  if (!initialCspNonce) return
  event.data.newBody.querySelectorAll('script[nonce]').forEach((script) => {
    script.setAttribute('nonce', initialCspNonce)
  })
})
